const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

// Escapa el texto de usuario antes de insertarlo como HTML: sin esto, un mensaje con
// `<img onerror=...>` se ejecutaria en el navegador de quien lo lea.
export function escapeHtml(text: string | null | undefined): string {
  if (!text) return '';
  return text.replace(/[&<>"']/g, char => HTML_ESCAPES[char]);
}
